<template>
    <div class="tab-menu-wrap" v-if="$store.getters.getHost != 'H0009'">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><router-link to="/kr/centerList"> 센터소개 </router-link></li>
            <li class="tab-menu__item"><router-link to="/kr/doctorList"> 의료진검색 </router-link></li>
        </ul>
    </div>
    <div class="list-form">
        <ul class="list-form__list">
            <li class="list-form__item" v-for="center in centerList">
                <router-link :to="`/kr/center?deptCd=${center.deptCd}`">
                    <span class="icon"><img :src="`/displayFile.do?name=${center.thumbAttach.savedName}`" alt="" v-if="center.thumbAttach && center.thumbAttach.savedName"></span>
                    <span>{{center.deptNm}}</span>
                </router-link>
            </li>
        </ul>
    </div>

</template>

<script>
export default {
    data() {
        return {
            centerList: []
        }
    },
    mounted() {
        this.axios.get(this.api.department.list, {
            params: {
                hospId: this.$store.getters.getHost,
                deptType: 1,
                startIndex: 1,
                langCd: this.$store.getters.getLang,
                orderType: 'sortOrd'
            }
        }).then(res => {
            this.centerList = res.data
            if(this.centerList?.length > 0) this.centerList = this.centerList.filter(item => item.deptCd != 'BHL')
        })
    },
}
</script>